import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerLinks1 = ['Shoes', 'Hoodies/Sweaters', 'T-Shirts', 'Jackets'];
  const footerLinks2 = ['Pants/Shorts', 'Headwear', 'Sets', 'Underwear'];
  const footerLinks3 = ['Jersey', 'Accessories', 'Bags', 'Belts'];

  const socialLinks = [
    { label: 'Twitter', href: '#' },
    { label: 'Pinterest', href: '#' },
    { label: 'Reddit', href: '#' },
    { label: 'Quora', href: '#' },
  ];

  const getCategoryUrl = (name: string): string => {
    const cat = categories.find((c) => c.name === name);
    return cat ? cat.url : '#';
  };

  return (
    <footer className="bg-foreground-900 mx-4 md:mx-10 mb-4 md:mb-10 rounded-2xl">
      <div className="px-6 md:px-12 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3">
            <Link
              to="/"
              className="font-heading text-2xl font-bold text-background-50 tracking-tight whitespace-nowrap"
            >
              Kakobuy<span className="text-primary-400">Finds</span>
            </Link>
            <p className="text-foreground-400 text-sm mt-4 leading-relaxed max-w-xs">
              Your trusted resource for curated Kakobuy Spreadsheet finds, shopping guides, and expert product comparisons.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4 uppercase tracking-wider">
                Categories
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks1.map((name) => (
                  <li key={name}>
                    <a
                      href={getCategoryUrl(name)}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-500 hover:text-background-50 text-sm transition-colors"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4 uppercase tracking-wider">
                &nbsp;
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks2.map((name) => (
                  <li key={name}>
                    <a
                      href={getCategoryUrl(name)}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-500 hover:text-background-50 text-sm transition-colors"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4 uppercase tracking-wider">
                &nbsp;
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks3.map((name) => (
                  <li key={name}>
                    <a
                      href={getCategoryUrl(name)}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-500 hover:text-background-50 text-sm transition-colors"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-foreground-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-wrap gap-4">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-500 hover:text-background-50 text-sm underline transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
          <div className="text-right">
            <p className="font-heading text-background-200 text-lg italic">
              &copy; KakobuyFinds {new Date().getFullYear()}
            </p>
            <p className="text-foreground-500 text-xs mt-1">
              All rights reserved. Curated with care.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}